import { render, staticRenderFns } from "./ServiceHallLayout.vue?vue&type=template&id=a313c70c&scoped=true&"
import script from "./ServiceHallLayout.vue?vue&type=script&lang=js&"
export * from "./ServiceHallLayout.vue?vue&type=script&lang=js&"
import style0 from "./ServiceHallLayout.vue?vue&type=style&index=0&id=a313c70c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a313c70c",
  null
  
)

export default component.exports